import {isMobile} from "../../js/global-scripts";

const personCards = [...document.querySelectorAll('.person-card')]

personCards.forEach( card => {
    card.addEventListener('mouseenter', personCardHandler)
    card.addEventListener('mouseleave', personCardHandler)
    card.addEventListener('click', personCardHandler)
})

function personCardHandler(e) {
    switch (e.type) {
        case 'mouseenter':
            if (!isMobile.any()) {
                e.currentTarget.classList.add('is-active')
            }
            break
        case 'mouseleave':
            if (!isMobile.any()) {
                e.currentTarget.classList.remove('is-active')
            }
            break
        case 'click':
            if (isMobile.any()) {
                const activeCard = document.querySelector('.person-card.is-active')

                if (activeCard === e.currentTarget) {
                    e.currentTarget.classList.remove('is-active')
                    return
                }

                activeCard?.classList.remove('is-active')
                e.currentTarget.classList.add('is-active')
            }
            break
    }
}

const moreButtons = [...document.querySelectorAll('.team-grid-more-btn')]
moreButtons.forEach(btn => {
    btn.addEventListener('click', showMore)
})

const grids = [...document.querySelectorAll('.team-grid')]
window.addEventListener('resize', updCards)
updCards();

function showMore(e) {
    e.preventDefault()
    const grid = e.currentTarget.closest('.team-grid')
    grid.classList.add('expanded')

    ;[...grid.querySelectorAll('.person-card')].forEach(card => card.classList.remove('is-hidden'))
}

function updCards() {
    grids.forEach( grid => {
        if (grid.classList.contains('expanded')) return
        const cards = [...grid.querySelectorAll('.person-card')]

        if (window.matchMedia('(min-width: 768px)').matches) {
            cards.forEach(card => card.classList.remove('is-hidden'))
            return
        }

        cards.forEach( (card, i) => i > 3 && (card.classList.add('is-hidden')) )
    })
}